import { dispatcher } from '../../../../helpers/projectHelper';
import { setGlobalFov } from '../../../../redux/slicers/camera/cameraSettings';

export class UndoRedoFov {
  constructor({ undoRedoInstance, unityContext }) {
    this.undoRedo = undoRedoInstance;
    this.unityContext = unityContext;

    this.init();
  }

  init = () => {
    this.changeFov = this.undoRedo.createAction(({ fov, prevFov }) => {
      const historyValue = {
        data: {
          fov,
          prevFov,
        },
        undo: () => {
          dispatcher(setGlobalFov(prevFov));
          this.unityContext.handleCameraFov(prevFov);
        },
        redo: () => {
          dispatcher(setGlobalFov(fov));
          this.unityContext.handleCameraFov(fov);
        },
      };
      return historyValue;
    });
  };
}
